module.exports = __webpack_public_path__ + "img/manage.58dc11a9.svg";